import React, { useState, useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { Clipboard } from '@capacitor/clipboard';
import { Capacitor } from '@capacitor/core';
import { Login_Form } from '../../atomstore/store';
import { useRequestProcessor } from '../../requestProcessor';
import { handleLogin, handleVerifyOtp } from '../../queryfunctions/queryfunctions';
import SpinnerLoading from '../common/SpinnerLoading';
import { Mail } from 'lucide-react';
import manifest from "../../manifest.json"
import FootpringSvg from "../../assets/splash-nico-hi.png"
import { useNavigate } from 'react-router-dom';




const Login = () => {

    const [loginStep, setLoginStep] = useState('mobile');
    const [otp, setOtp] = useState('');
    const [form, setForm] = useAtom(Login_Form);
    const otpInputRef = useRef(null);
    const isNative = Capacitor.isNativePlatform();
    const [timer, setTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);

    const navigate = useNavigate()
    const { useMutationWrapper } = useRequestProcessor();

    const sendOtpMutation = useMutationWrapper('SendOtp', () =>
        handleLogin(form, setForm, setLoginStep)
    );


    // useEffect(() => {
    //     if (timer === 0) {
    //         setCanResend(true);
    //         return;
    //     }

    //     const interval = setInterval(() => {
    //         setTimer((prev) => prev - 1);
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, [timer]);


    useEffect(() => {
        if (loginStep !== 'otp') return;

        setTimer(30);
        setCanResend(false);

        const interval = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [loginStep]);





    // ✅ Pass OTP directly here (don’t rely on form.otp)
    const verifyOtpMutation = useMutationWrapper('VerifyOtp', (otpValue) =>
        handleVerifyOtp(form, setForm, otp, otpValue, navigate), {}
    );

    const validate = () => {
        if (form.phone === '' && form.email === '') {
            setForm({ ...form, error: 'Please enter phone number or email id' });
            return false;
        } else if (
            form.phone &&
            (!form.phone.match(/^[0-9]+$/) || form.phone.length !== 10)
        ) {
            setForm({ ...form, error: 'Please enter a valid 10-digit number' });
            return false;
        }
        return true;
    };

    const sendOtp = () => {
        setForm({ ...form, error: '' });
        if (validate()) {
            sendOtpMutation.mutate(undefined, {
                onSuccess: () => {
                    console.log("inside this confirm ")
                    // setLoginStep('otp')
                },
            });
        }
    };

    // ✅ Always use the OTP passed or current state
    const verifyOtp = (code) => {
        console.log("verifyOtp", code);
        const finalOtp = code || otp;
        console.log("finalOtp", finalOtp);
        if (!finalOtp || finalOtp.length < 4) {
            setForm({ ...form, error: 'Please enter valid OTP' });
            return;
        }

        // Update local form (for UI only)
        setForm({ ...form, otp: finalOtp, error: '' });

        // Call mutation with the correct OTP
        verifyOtpMutation.mutate(finalOtp, {
        });
    };

    // ✅ Clipboard polling (Capacitor or Web)
    useEffect(() => {
        if (loginStep !== 'otp') return;

        const readClipboard = async () => {
            try {
                let value = '';
                if (Capacitor.isNativePlatform()) {
                    const res = await Clipboard.read();
                    value = res?.value ?? '';
                } else if (navigator.clipboard?.readText) {
                    value = await navigator.clipboard.readText();
                }

                const clean = String(value).trim().replace(/\D/g, '');
                if (clean.length === 6 && clean !== otp) {
                    setOtp(clean);
                    verifyOtp(clean); // ✅ Works now — OTP passed directly
                }
            } catch (err) {
                console.warn('Clipboard read error', err);
            }
        };

        const interval = setInterval(readClipboard, 1500);

        // optional: clear clipboard first
        (async () => {
            try {
                if (Capacitor.isNativePlatform()) {
                    await Clipboard.write({ string: '' });
                } else if (navigator.clipboard?.writeText) {
                    await navigator.clipboard.writeText('');
                }
            } catch { }
        })();

        return () => clearInterval(interval);
    }, [loginStep, otp]);


    // const handleResendOtp = async () => {
    //     if (!canResend) return;

    //     try {
    //         setCanResend(false);
    //         setTimer(30);

    //         sendOtp();// your API call here

    //     } catch (error) {
    //         console.error("Failed to resend OTP", error);
    //     }
    // };


    const handleResendOtp = () => {
        if (!canResend) return;

        setTimer(30);
        setCanResend(false);
        sendOtp();
    };


    return (
        <div className="h-dvh bg-gradient-to-br from-blue-50 to-cyan-50 flex flex-col items-center justify-center p-6">
            {(sendOtpMutation?.isLoading || verifyOtpMutation?.isLoading) && <SpinnerLoading />}
            <div className="text-center mb-8">
                <h1 className="text-4xl font-black tracking-wider mb-2" style={{ color: '#00BCD4' }}>
                    FOOTPRINTS
                </h1>
            </div>
            <div className="bg-white rounded-3xl shadow-xl p-8 w-full max-w-md">

                <p className="text-2xl text-gray-600 font-semibold mb-4 flex text-center items-center">
                    <img src={FootpringSvg} className="h-12" alt="logo" />
                    &nbsp;
                    ParentConnect</p>

                {loginStep === 'mobile' ? (
                    <div className="">
                        <div className="mb-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Mobile Number
                            </label>

                            <div className="flex w-full items-center">
                                <span
                                    className="flex-shrink-0 inline-flex items-center px-3 py-3 rounded-l-xl border border-r-0 border-gray-300 bg-gray-50 text-gray-600"
                                >
                                    +91
                                </span>

                                <input
                                    type="tel"
                                    value={form.phone}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            phone: e.target.value,
                                            email: '',
                                            error: '',
                                        })
                                    }
                                    placeholder="Enter mobile number"
                                    className="flex-1 min-w-0 px-4 py-3 border border-gray-300 rounded-r-xl 
                       focus:ring-cyan-500 outline-none focus:ring-2 appearance-none focus:border-transparent"
                                    maxLength="10"
                                />
                            </div>
                        </div>

                        <h2 className='text-center'>OR</h2>
                        <div className='mb-6'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Email
                            </label>

                            <div className="flex w-full items-center">
                                <span
                                    className="flex-shrink-0 inline-flex items-center px-3 py-3 rounded-l-xl border border-r-0 border-gray-300 bg-gray-50 text-gray-600"
                                >
                                    <Mail />
                                </span>

                                <input
                                    type="text"
                                    value={form.email}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            phone: '',
                                            email: e.target.value,
                                            error: '',
                                        })
                                    }
                                    placeholder="Enter email"
                                    className="flex-1 min-w-0 px-4 py-3 border border-gray-300 rounded-r-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent outline-none appearance-none"
                                />
                            </div>
                        </div>

                        {form.error && <p className="text-red-500 text-sm">{form.error}</p>}
                        <button
                            onClick={sendOtp}
                            className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition"
                        >
                            {sendOtpMutation.isPending ? 'Sending OTP...' : 'Send OTP'}
                        </button>

                        <p className='font-semibold text-center mt-2'>Parent Connect v{manifest?.version}</p>
                    </div>
                ) : (
                    <div className="">
                        <div className=''>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Enter OTP
                            </label>
                            <p className="text-sm text-gray-500 mb-4">
                                Sent to {form.phone ? `+91 ${form.phone}` : form.email}

                            </p>
                            <input
                                ref={otpInputRef}
                                type="text"
                                inputMode="numeric"
                                value={otp}
                                onChange={(e) => {
                                    // Strip non-digits ONLY on web
                                    const clean = isNative ? e.target.value : e.target.value.replace(/\D/g, "");
                                    setOtp(clean);
                                }}
                                placeholder="Enter 6-digit OTP"
                                className=" flex-1 min-w-0 w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-center text-2xl tracking-widest outline-none appearance-none"
                                maxLength="6"
                            />
                        </div>
                        {form.error && <p className="text-red-500 text-sm">{form.error}</p>}
                        <div className="resend-section text-center  m-2">
                            {canResend ? (
                                <button
                                    onClick={handleResendOtp}
                                    className="resend-btn underline"
                                >
                                    Resend OTP
                                </button>
                            ) : (
                                <span className="timer-text text-center">
                                    <span className='text-gray-500'>Resend Code in </span>
                                    00:{timer.toString().padStart(2, "0")}
                                </span>
                            )}
                        </div>
                        <button
                            onClick={() => verifyOtp()}
                            className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition mb-2"
                        >
                            {verifyOtpMutation.isPending ? 'Verifying...' : 'Verify & Login'}
                        </button>
                        <button
                            onClick={() => setLoginStep('mobile')}
                            className="w-full text-cyan-500 py-2 text-sm mb-2"
                        >
                            {form?.phone ? "Change Number" : "Change Email"}
                        </button>
                        <p className='font-semibold text-center mt-2'>Parent Connect v{manifest?.version}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
